
import { useQuery } from "@tanstack/react-query";
import { getConsultationByid } from "../requests/consultations";

export const useConsultation = (id: string) => {
  const { data, isLoading, isFetching, isPending } = useQuery({
    queryKey: ["consultations", id],
    queryFn: () => getConsultationByid(id),
    enabled: !!id,
    staleTime: 1000 * 60 * 10,
  })

  return {
    data,
    isLoading,
    isFetching,
    isPending,
  }
}
